import { Image } from '@skytech/ui/Image'

import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'

import './product-visualizer.scss'

const ProductVisualizer = ({ products }: any) => {
  if (!products) return null

  return (
    <div className="product-visualizer">
      {products.map((product: any, idx: any) => (
        <Product key={idx} {...product} />
      ))}
    </div>
  )
}

export const Product = ({ imgUrl, model, price }: any) => {
  const { formatNumber } = useFormattedNumberWithCurrency()

  return (
    <div
      className="product-visualizer__product"
      title={model && `${model} - ${formatNumber({ amount: price ? Number(price) : 0 })}`}
    >
      <Image src={imgUrl} alt="product" />
    </div>
  )
}

export default ProductVisualizer
